import { render } from "./OpportunityDataDetail.vue?vue&type=template&id=2628e853"
import script from "./OpportunityDataDetail.vue?vue&type=script&lang=js"
export * from "./OpportunityDataDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__